import { SBack, SDrawerOrModal, SMessage, STitle } from 'shj-components'
import styles from './index.module.less'
import { Button, Form, Input, message, Select, Space, Spin, Tabs, Tooltip } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { numFormat } from 'shj-components/dist/es/SFilterTable'

import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import ContractModal from '@/components/ContractModal'
import { getBudgetPrintInfoMap } from '@/services/goods.ts'
import {
  chooseCheck,
  quoteBudgetSelectQuoteBudgetInfo,
  checkTemplateUpdate,
  selectMainSpaceSpec,
  changeBaseInfo,
  getAllSapce,
} from '@/services/order'
import _, { cloneDeep, isEmpty } from 'lodash'
import BudgetPrice from './components/budgetPrice'
import { getAuth } from '@/utils/btn.ts'
import { EditOutlined, FormOutlined, SwapOutlined, SyncOutlined } from '@ant-design/icons'
import ChooseMaterial from './ChooseMaterial'
import tagsMap from './utils'
import ProgramProcessModal from '@/components/ProgramProcess'
import ProcessRecord from '@/components/ProcessRecord'
import { getUser } from '@/common/utils'
import refresh from '@/assets/refresh.png'

export default function QuoteSpaceSelection() {
  const navigate = useNavigate()
  const { budgetId } = useParams() // 报价id
  const chooseMaterialRef = useRef<any>()
  const [searchParams] = useSearchParams()
  const [treeChildrenItems, setTreeChildrenItems] = useState<any>([]) // 树形分类选中数据的子项
  const [lastChidrenItems, setLastChidrenItems] = useState<any>([]) // 项目子项或者子项的子项
  const [contractMap, setContractMap] = useState({})
  const [openContractModal, setOpenContractModal] = useState(false)
  const [quoteBudgetInfo, setQuoteBudgetInfo] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [errorObj, setErrorObj] = useState<any>('') // 选材检查错误列表
  const orderState = searchParams.get('orderState')
  const orderId = searchParams.get('orderId')
  const goBackActiveKey = searchParams.get('activeKey')
  const auths = getAuth() || {}
  const [spaceList, setSpaceList] = useState<any>([])
  const [activeKey, setActiveKey] = useState<any>('priceDetail')
  const [programProcessModalOpen, setProgramProcessModalOpen] = useState(false) // 方案审核弹窗
  const [openProcessRecordModal, setOpenProcessRecordModal] = useState(false)
  const user = getUser()

  // 1. 初始化
  const [initFlag, setInitFlag] = useState(true)
  const budgetPriceRef = useRef<any>(null)
  useEffect(() => {
    checkUpdate()
    getSpaceList()
    if (goBackActiveKey) {
      setActiveKey(goBackActiveKey)
    }
    gio?.('setUserId', user?.workNumber)
    gio?.('people.set', {
      tenantId: user?.tenantId, //租户ID,
      ucenterUserName: user?.name, // 平台用户名称
      ucenterUserId: user?.id, //平台用户ID
      loginWorkNumber: user?.workNumber, //登录工号
      phone: user?.phone, //手机号
    })
    return () => {
      document.title = '积木云装'
    }
  }, [])
  const getSpaceList = async () => {
    let resList: any = await getAllSapce(budgetId)
    setSpaceList(resList || [])
  }
  const checkUpdate = () => {
    console.log('初始化', initFlag)
    setLoading(true)
    if (initFlag) {
      checkTemplateUpdate({
        params: {
          budgetId: budgetId,
        },
      })
        .then((res: any) => {
          if (res?.requireUpdateFlag) {
            // 需要弹窗更新
            SMessage.confirm({
              title: `打包数据有更新，点击继续进行数据更新`,
              content: '该更新只对配置变更的数据更新，不会影响非变更数据的已有选材',
              okText: '继续',
              onOk: () => {
                return checkTemplateUpdate({
                  params: {
                    budgetId: budgetId,
                    updateFlag: true,
                  },
                })
                  .then((res: any) => {
                    getTopData()
                  })
                  .catch((err: any) => {
                    // goBack()
                    getTopData()
                  })
              },
              onCancel: () => {
                // goBack()
                getTopData()
              },
            })
          } else {
            getTopData()
          }
        })
        .finally(() => {
          getTopData()
          setLoading(false)
          setInitFlag(false)
        })
    } else {
      getTopData()
      setLoading(false)
    }
  }

  const getTopData = (handle?: any) => {
    handle && setLoading(true)
    quoteBudgetSelectQuoteBudgetInfo({
      params: {
        quoteBudgetId: budgetId,
      },
    })
      .then((res: any) => {
        setQuoteBudgetInfo(res || {})
        handlebaseInfo(res)
        handle && message.success('刷新成功')
        setErrorObj(null)
        document.title = res?.customerName + '-预算详情'
      })
      .finally(() => {
        handle && setLoading(false)
      })
  }
  const handleSubmitContract = async () => {
    try {
      if (budgetId) {
        const res = await getBudgetPrintInfoMap([budgetId])
        setContractMap(res || {})
        setOpenContractModal(true)
      } else {
        message.error('无报价ID')
      }
    } catch (err) {
      console.log(err)
    }
  }

  const goBack = () => {
    localStorage.removeItem('quoteSelectionSearch')
    navigate(`/order/list/details/${orderId}`)
  }
  const checkMaterial = () => {
    setLoading(true)
    // 选材检查
    chooseCheck({
      params: {
        budgetId: budgetId,
      },
    })
      .then((res: any) => {
        setErrorObj(res)
        let content
        if (res?.itemList?.length) {
          content = (
            <span>
              选材检查完成，共有
              <span style={{ color: '#EB3723' }}>
                {res?.itemList?.length}
                个空间
              </span>
              待完成
            </span>
          )
          message.warning(content)
        } else {
          message.success('选材检查完成')
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const getNewestPrice = () => {
    // 刷新价格
    getTopData('handle')
  }
  useEffect(() => {
    // 检查报错项目
    if (errorObj) {
      let newTreeChildItems = _.cloneDeep(treeChildrenItems)
      let newLastChidrenItems = _.cloneDeep(lastChidrenItems)
      // 添加项目报错提示
      if (newTreeChildItems && newTreeChildItems.length) {
        newTreeChildItems.map((item: any) => {
          if (errorObj.itemIdList?.includes(item.id)) {
            item.status = 'danger'
          }
          return item
        })
        setTreeChildrenItems([...newTreeChildItems])
      }
      if (newLastChidrenItems && newLastChidrenItems.length) {
        newLastChidrenItems.map((item: any) => {
          if (errorObj.itemIdList?.includes(item.id)) {
            item.status = 'danger'
          }
          return item
        })
        setLastChidrenItems([...newLastChidrenItems])
      }
    }
  }, [errorObj])

  // 重构改造数据

  const [skuArgList, setSkuArgList] = useState<any>([])
  const [btnLoding, setBtnLoding] = useState(false)
  const [spaceArgList, setSpaceArgList] = useState<any>([])
  const [form] = Form.useForm()
  const [open, setOpen] = useState(false)
  const [lastFormValue, setLastFormValue] = useState({})

  const handlebaseInfo = async quoteBudgetInfo => {
    if (quoteBudgetInfo?.skuArgJson) {
      let skuArgList = JSON.parse(quoteBudgetInfo?.skuArgJson || '[]')
      setSkuArgList(skuArgList)
      let roomNum = 0
      let toiletNum = 0
      skuArgList.forEach((arg: any) => {
        if (!isNaN(Number(arg?.argVal))) {
          switch (arg.argCode) {
            case 'BED_ROOM':
              roomNum = Number(arg?.argVal)
              break
            case 'toilet_num':
              toiletNum = Number(arg?.argVal)
              break
          }
        }
      })
      const res = await selectMainSpaceSpec({
        quoteBudgetId: budgetId,
        roomNum,
        toiletNum,
      })
      if (Array.isArray(res)) {
        setSpaceArgList(res)
        form.setFieldValue('spaceQuoteBudgetItemList', res)
      }
    }
  }
  const handleShow = () => {
    let flag = skuArgList.some((item: any) => item.argType === 'INPUT')
    return flag
  }
  const clickToOpen = () => {
    setOpen(true)
  }
  useEffect(() => {
    if (open && skuArgList?.length) {
      handlebaseInfo(quoteBudgetInfo)
    }
    if (!open) {
      form.resetFields()
    }
  }, [open])
  const onSubmit = () => {
    form.validateFields().then(values => {
      setBtnLoding(true)
      let newSkuArgList: any = cloneDeep(skuArgList)
      newSkuArgList.forEach((item: any) => {
        if (values[item.argCode]) {
          item.argVal = values[item.argCode]
        }
      })
      changeBaseInfo({
        data: {
          budgetId: budgetId,
          skuArgJsonList: newSkuArgList,
          spaceQuoteBudgetItemList: values.spaceQuoteBudgetItemList,
        },
      })
        .then(() => {
          setOpen(false)
          setBtnLoding(false)
          setSkuArgList(newSkuArgList)
          // init()
          // props?.reloadList && props?.reloadList()
          getTopData()
          chooseMaterialRef?.current?.reloadSpace()
          message.success('修改成功')
        })
        .catch(() => {
          setBtnLoding(false)
        })
    })
  }
  const spaceChange = (changedValues, allValues) => {
    const argCodeList = skuArgList?.map((item: any) => item.argCode)
    if (changedValues && !argCodeList?.includes(Object.keys(changedValues)?.[0])) {
      setLastFormValue(allValues)
      return
    }
    let roomNum: any = 0
    let toiletNum: any = 0
    skuArgList.forEach((arg: any) => {
      const value = allValues[arg.argCode]
      if (arg.argCode === 'BED_ROOM' && value && !isNaN(Number(value))) {
        roomNum = Number(value)
      } else if (arg.argCode === 'toilet_num' && value && !isNaN(Number(value))) {
        toiletNum = Number(value)
      }
    })
    if (roomNum !== '' && toiletNum !== '') {
      selectMainSpaceSpec({
        quoteBudgetId: budgetId,
        roomNum,
        toiletNum,
      })
        .then(res => {
          if (Array.isArray(res)) {
            setSpaceArgList(res)
            console.log(res, 'res')
            form.setFieldValue('spaceQuoteBudgetItemList', res)
          }
          setLastFormValue(form.getFieldsValue())
        })
        .catch(() => {
          if (Object.keys(changedValues || {})?.[0]) {
            form.setFieldValue(
              Object.keys(changedValues || {})?.[0],
              lastFormValue?.[Object.keys(changedValues || {})?.[0]]
            )
          }
        })
    } else {
      setLastFormValue(allValues)
    }
  }
  const onChange = (key: string) => {
    console.log(key)
    setActiveKey(key)
  }

  const items = [
    {
      key: 'priceDetail',
      label: '报价',
      children: (
        <BudgetPrice
          reloadList={() => {
            getTopData()
          }}
          couldEdit={quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag}
          quoteBudgetInfo={quoteBudgetInfo}
          ref={budgetPriceRef}
        ></BudgetPrice>
      ),
    },
    {
      key: 'chooseMaterial',
      label: spaceList && spaceList?.length > 0 ? '选材' : null,
      children: (
        <ChooseMaterial
          quoteBudgetInfo={quoteBudgetInfo}
          budgetId={budgetId}
          errorObj={errorObj}
          getTopData={getTopData}
          ref={chooseMaterialRef}
        ></ChooseMaterial>
      ),
    },
  ]
  const clickToChangeVersion = () => {
    localStorage.setItem('versionChange', 'old')
    gio?.('track', 'detailsOldVersionButton', {
      user_id: user?.workerNumber,
      event_time: new Date().getTime(),
    })
    navigate(
      `/order/list/details/quote-selection/${budgetId}?orderState=${orderState}&orderId=${orderId}`
    )
  }
  const priceHandle = price => {
    if (price) {
      let priceStr = numFormat({ value: price })
      const [int, dec] = priceStr.split('.')
      if (Number(dec)) {
        return (
          <>
            {int}
            <span className={styles.priceBoxSmall}>.{dec}</span>
          </>
        )
      } else {
        return int
      }
    } else {
      return <span>{0}</span>
    }
  }
  const clickTopreview = () => {
    navigate(
      `/order/list/details/quote-space-selection/preview-list/${budgetId}?orderState=${orderState}&orderId=${orderId}`
    )
  }
  const openProgramProcess = () => {
    setProgramProcessModalOpen(true)
  }
  const openProgramRecord = (record: any) => {
    // setState({ record })
    setOpenProcessRecordModal(true)
  }
  const extrabtns = () => {
    if (activeKey === 'chooseMaterial') {
      return (
        <div style={{ margin: '12px 0' }}>
          {spaceList && spaceList?.length > 0 && (
            <Button
              color="primary"
              variant="outlined"
              onClick={checkMaterial}
              style={{ marginRight: '12px' }}
            >
              选材检查
            </Button>
          )}
          {spaceList && spaceList?.length > 0 && (
            <Button color="primary" variant="outlined" onClick={clickTopreview}>
              选材清单
            </Button>
          )}
        </div>
      )
    }
    return null
  }
  return (
    <SBack
      title={'预算详情'}
      level={2}
      goPath={goBack}
      gutter={0}
      extra={
        auths['ChangeVersion'] && (
          <Button type="link" onClick={clickToChangeVersion}>
            <SwapOutlined /> 切回旧版选材
          </Button>
        )
      }
    >
      <Spin spinning={loading} wrapperClassName="base-space-spin-wrapper">
        <div className={styles.contentBox}>
          <div className={styles.topBox}>
            <div className={styles.topTitleBox}>
              <div className={styles.topTitleBox_left}>
                <div
                  className={'normal_tag_style'}
                  style={{
                    color: tagsMap['BUDGETTYPE']?.color,
                    backgroundColor: tagsMap['BUDGETTYPE']?.bgColor,
                    marginRight: '8px',
                    float: 'unset',
                    maxWidth: '100px',
                  }}
                >
                  {quoteBudgetInfo?.typeDisplay}
                </div>
                <div className={styles.topTitleName}>{quoteBudgetInfo?.quoteGoodsName}</div>
              </div>
              <div className={styles.topTitleBox_right}>
                <div className={styles.baseInfoBtnBox}>
                  {auths['starting_contract'] && (
                    <Button type="primary" onClick={handleSubmitContract}>
                      发起合同
                    </Button>
                  )}
                  {quoteBudgetInfo?.diagramReviewFlag ? (
                    <Button
                      disabled={quoteBudgetInfo?.frozenFlag}
                      type="primary"
                      onClick={openProgramProcess}
                    >
                      发起方案审核
                    </Button>
                  ) : null}
                  {quoteBudgetInfo?.diagramReviewFlag ? (
                    <Button
                      disabled={quoteBudgetInfo?.frozenFlag}
                      onClick={openProgramRecord}
                      color="primary"
                      variant="outlined"
                    >
                      审核记录
                    </Button>
                  ) : null}

                  <Button variant="outlined" onClick={getNewestPrice} style={{ padding: '0 8px' }}>
                    <Tooltip title="刷新">
                      <SyncOutlined />
                    </Tooltip>
                  </Button>
                </div>
              </div>
            </div>
            <div className={styles.content_top}>
              <div className={styles.normal_text}>
                <span className={styles.normal_text}>客户名称：</span>
                <span className={styles.normal_main_text}>{quoteBudgetInfo?.customerName}</span>
              </div>
              <div className={styles.priceBox}>
                <span className={styles.normal_text}>合同金额：</span>
                <span className={styles.priceBoxSmall}>￥</span>
                {<>{priceHandle(quoteBudgetInfo?.contractAmount)}</>}
              </div>
            </div>
            <div className={styles.topContentBox}>
              <div className={styles.baseInfoBox}>
                <div className={styles.baseInfoBox_baseInfo}>
                  {handleShow() ? (
                    <p>
                      {skuArgList.map((item: any) => {
                        if (item?.argType === 'INPUT' && !item?.addFlag) {
                          const text = `${item?.argName}：${item?.argVal || ''}  `
                          return <span style={{ marginRight: '24px' }}>{text}</span>
                        }
                      })}
                    </p>
                  ) : null}
                  {quoteBudgetInfo?.spaceQuoteBudgetItemList?.filter(
                    item => item.spaceSpecParamValueId
                  )?.length ? (
                    <p>
                      <span style={{ marginRight: '24px' }}>丨</span>
                      {quoteBudgetInfo?.spaceQuoteBudgetItemList
                        ?.filter(item => item.spaceSpecParamValueId)
                        ?.map(item => {
                          const text = `${item?.showName}：${item?.spaceSpecParamValueName}  `
                          return <span style={{ marginRight: '24px' }}>{text}</span>
                        })}
                    </p>
                  ) : null}
                </div>
                {quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag && (
                  <EditOutlined
                    onClick={clickToOpen}
                    style={{ color: '#0053cf', fontSize: '16px' }}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={styles.tabContentBox}>
            <Tabs
              // defaultActiveKey="priceDetail"
              items={items}
              activeKey={activeKey}
              destroyInactiveTabPane
              onChange={onChange}
              tabBarExtraContent={extrabtns()}
            />
          </div>
        </div>
        {/* 发起合同 */}
        {openContractModal && (
          <ContractModal
            open={openContractModal}
            closeDialog={() => setOpenContractModal(false)}
            contractMap={contractMap}
          />
        )}
        {programProcessModalOpen && (
          <ProgramProcessModal
            title="发起方案审核"
            quoteId={budgetId || ''}
            setOpen={setProgramProcessModalOpen}
            open={programProcessModalOpen}
            reload={getTopData}
          />
        )}
        {openProcessRecordModal ? (
          <ProcessRecord
            title="审核记录"
            open={openProcessRecordModal}
            setOpen={setOpenProcessRecordModal}
            quoteBudgetId={budgetId || ''}
          />
        ) : null}
        <SDrawerOrModal
          mode="modal"
          title="编辑"
          open={open}
          loading={btnLoding}
          onCancel={() => setOpen(false)}
          // styles={{ body: { padding: '0 15px' } }}
          width={500}
          onOk={onSubmit}
          antdProps={{
            destroyOnClose: true,
          }}
        >
          <div className="budgetPriceEditModal">
            <Form form={form} onValuesChange={spaceChange} labelWrap layout="vertical">
              {skuArgList?.length ? <STitle title={'商品规格'} /> : null}
              {skuArgList?.map((item: any) => {
                if (item.argType === 'INPUT') {
                  return (
                    <Form.Item
                      label={item?.argName}
                      name={item?.argCode}
                      rules={[{ required: true, message: '请输入' }]}
                      initialValue={item?.argVal}
                      style={{
                        display: item.addFlag ? 'none' : 'block',
                      }}
                    >
                      <Input />
                    </Form.Item>
                  )
                }
              })}
              {/* 空间规格 */}
              {spaceArgList?.length &&
              form
                .getFieldValue('spaceQuoteBudgetItemList')
                ?.filter((item: any) => item.spaceSpecParamValues?.length)?.length ? (
                <STitle title={'空间规格'} />
              ) : null}
              {spaceArgList?.length ? (
                <Form.List name="spaceQuoteBudgetItemList">
                  {fields =>
                    fields.map((field: any, index) => (
                      <Form.Item
                        {...field}
                        name={[index, 'spaceSpecParamValueId']}
                        label={form.getFieldValue('spaceQuoteBudgetItemList')?.[index]?.showName}
                        rules={[
                          {
                            required: form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                              ?.spaceSpecParamValues?.length
                              ? true
                              : false,
                            message: `${
                              form.getFieldValue('spaceQuoteBudgetItemList')?.[index]?.showName
                            }不能为空`,
                          },
                        ]}
                        style={{
                          display: form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                            ?.spaceSpecParamValues?.length
                            ? 'block'
                            : 'none',
                        }}
                      >
                        <Select
                          placeholder={`请输入${
                            form.getFieldValue('spaceQuoteBudgetItemList')?.[index]?.showName
                          }`}
                          style={{ width: '100%', maxWidth: 460 }}
                          allowClear
                          showSearch
                          optionFilterProp={'name'}
                          options={
                            form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                              ?.spaceSpecParamValues || []
                          }
                          fieldNames={{
                            label: 'argValue',
                            value: `id`,
                          }}
                        ></Select>
                      </Form.Item>
                    ))
                  }
                </Form.List>
              ) : null}
            </Form>
            <p style={{ color: 'red' }}>
              若减少卧室个数、卫生间个数可能会丢失已选材数据，请谨慎操作！
            </p>
          </div>
        </SDrawerOrModal>
      </Spin>
    </SBack>
  )
}
